// import { useSelector } from "react-redux";
// import { Navigate } from "react-router-dom";
// import { normalizeRole } from "../utils/rbacHelper";

// export default function ProtectedRoute({ children, requiredRoles }) {
//   const user = useSelector((s) => s.auth.user);

//   // 1. Not logged in
//   if (!user) {
//     return <Navigate to="/login" replace />;
//   }

//   const userRole = normalizeRole(user.role);

//   // 2. Role Check
//   if (requiredRoles && !requiredRoles.map(normalizeRole).includes(userRole)) {

//     // 🛑 SMART REDIRECTS (USING EXACT ROLE STRINGS)

//     // Admin Staff → Admin Dashboard
//     if ([
//       'admin',
//       'manager',
//       'hr',
//       'field_emp',
//       'office_emp',
//       'sub_admin'
//     ].includes(userRole)) {
//       return <Navigate to="/dashboard" replace />;
//     }

//     // Group Admin
//     if (userRole === 'group_admin') {
//       return <Navigate to="/dashboard" replace />;
//     }

//     // User / Client
//     if (['user', 'client'].includes(userRole)) {
//       return <Navigate to="/dashboard" replace />;
//     }

//     // Viewer
//     if (userRole === 'viewer') {
//       return <Navigate to="/dashboard" replace />;
//     }

//     // Fallback
//     return <Navigate to="/dashboard" replace />;
//   }

//   // 3. Access Granted
//   return children;
// }



import { useSelector } from "react-redux";
import { Navigate, useLocation } from "react-router-dom";
import { hasUserPermission, normalizeRole } from "../utils/rbacHelper";

export default function ProtectedRoute({
  children,
  requiredRoles,
  requiredPermissions = [],
  requiredAnyPermission = [],
}) {
  const location = useLocation();
  const user = useSelector((s) => s.auth.user);
  const token = useSelector((s) => s.auth.token) || localStorage.getItem("token");

  // Token present hai lekin profile abhi restore ho rahi hai, loader mat dikhao.
  if (!user && token) {
    return null;
  }

  if (!user && !token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  const userRole = normalizeRole(user.role);

  if (requiredRoles && !requiredRoles.map(normalizeRole).includes(userRole)) {
    return <Navigate to="/dashboard" replace />;
  }

  if (
    Array.isArray(requiredPermissions) &&
    requiredPermissions.length > 0 &&
    !requiredPermissions.every((permissionKey) => hasUserPermission(user, permissionKey))
  ) {
    return <Navigate to="/dashboard" replace />;
  }

  if (
    Array.isArray(requiredAnyPermission) &&
    requiredAnyPermission.length > 0 &&
    !requiredAnyPermission.some((permissionKey) => hasUserPermission(user, permissionKey))
  ) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
